module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-Bold.94e9acf.eot";